import {
	Anchor,
	FormattedText,
	Space
} from "client/Components";
import { AlertManager } from "client/Hooks";
import { DocumentItemType } from "client/Api/Documents/SharePoint/common";
import { localize } from "client_legacy/ndaw/culture";
import {
	MouseEvent,
	ReactElement,
	useCallback
} from "react";
import { BookmarkModel, removeBookmarks } from "client/Api/Documents/Bookmarks/bookmarks";
import { BookmarkEvent, publish } from "client_legacy/Documents/Bookmarks/events";

export type BookmarkCouldNotBeOpenedAlertContentProps = {
	bookmark: BookmarkModel;
	alertManager: AlertManager;
};

export const BookmarkCouldNotBeOpenedAlertContent = (props: BookmarkCouldNotBeOpenedAlertContentProps): ReactElement => {
	const {
		bookmark,
		alertManager
	} = props;

	const clickHandler = useCallback(
		(args: MouseEvent): void => {
			args.preventDefault();
			const bookmarkIds: number[] = [bookmark.id];
			const bookmarkNames: string[] = [bookmark.name];

			removeBookmarks(bookmarkIds)
				.then(() => {
					alertManager.showSuccess(
						localize("_BookmarksRemovedForItemNames")
							.replace("{ItemNames}", bookmarkNames.join(", "))
					);

					publish(BookmarkEvent.Deleted, bookmarkIds);
				});
		},
		[
			alertManager,
			bookmark.id,
			bookmark.name
		]
	);

	return (
		<>
			{localize(typeToKeyMap[bookmark.itemType])}
			<Space />
			<FormattedText
				text={localize("_PleaseRetryOrClickHereToDeleteTheBookmark")}
				thingsToReplace={[
					{
						what: "{{Here}}",
						filler: (
							<Anchor onClick={clickHandler}>
								{localize("_Here")}
							</Anchor>
						)
					}
				]}
			/>
		</>
	);
};
BookmarkCouldNotBeOpenedAlertContent.displayName = "BookmarkCouldNotBeOpenedAlertContent";

const typeToKeyMap: Record<DocumentItemType, LocalizationKey> = {
	[DocumentItemType.Folder]: "_TheFolderCannotBeOpened",
	[DocumentItemType.OneNoteNotebook]: "_TheOneNoteNotebookCannotBeOpened",
	[DocumentItemType.File]: "_TheFileCannotBeOpened"
};
